import { getBaseUrl } from './baseUrl';

export async function waitForHealth(maxMs = 4000) {
  const start = Date.now();
  while (Date.now() - start < maxMs) {
    try {
      const base = await getBaseUrl();
      const r = await fetch(`${base}/api/health`);
      if (r.ok) return true;
    } catch {}
    await new Promise(r => setTimeout(r, 200));
  }
  return false;
}
